import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Illustration from '../components/illustrations/Illustration';
import {
  isGN,
  isGNC,
  isPPFundraising,
} from '../utility/externalIntegrationUtils';
import BannerHeader, { Banner } from '../components/GN/bannerHeader';
import templateData from '../utility/getTemplateData';

export class ConfirmationCheckmark extends Component {
  render() {
    return (
      <div>
        <input
          type="hidden"
          id="confirmationNumber"
          defaultValue={this.props.confirmationNumber}
        />
        <div>
          {isGN() || isGNC() ? (
            <BannerHeader type="banner">
              <Banner bannerURL={templateData.bannerUrl} />
            </BannerHeader>
          ) : (
            <div className="confirmation_img_holder center-block">
              <Illustration
                type={
                  isPPFundraising() ? 'pp_fundraising_success' : 'cause_success'
                }
                size={isPPFundraising() ? 'extraLarge' : 'max'}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ConfirmationCheckmark;

ConfirmationCheckmark.propTypes = {
  confirmationNumber: PropTypes.string,
};
